/**
 * Navigate to a URL, optionally in a new tab.
 *
 * Browsers block window.open() when it isn't triggered directly by a click
 * (e.g. from a timeout or after an async form submit). window.open() returns
 * null when blocked, so in that case we fall back to the current tab.
 */
const redirect = (url, target = '') => {
  if (target === '_blank') {
    // Not passing 'noopener' — it makes window.open() always return null,
    // which would hide whether the tab was blocked. Detach the opener instead.
    const win = window.open(url, '_blank');
    if (win) {
      win.opener = null;
      return;
    }
  }

  window.location.href = url;
};

export default redirect;
